/**
 * Affichage d’un montant. **Tout montant de l’interface passe par ici**
 * (ARCHITECTURE §9.4) : l’entrée est toujours un entier de centimes, la sortie
 * toujours le format suisse `1'234.50`.
 */

import { cn } from '../lib/cn'
import { ABSENT, formatMontant, formatMontantCourt } from '../lib/format'

export interface MoneyProps {
  /** Montant en **centimes entiers**. `null` affiche un tiret. */
  readonly centimes: number | null | undefined
  /** Préfixe « CHF ». */
  readonly avecDevise?: boolean | undefined
  /** Force le `+` sur un montant positif (ajustements — PAY-03). */
  readonly signeExplicite?: boolean | undefined
  /** `45.–` quand le montant est rond (grilles tarifaires). */
  readonly court?: boolean | undefined
  /** Colore le négatif en rouge (avoirs, remboursements). */
  readonly colorer?: boolean | undefined
  readonly className?: string | undefined
}

export function Money({
  centimes,
  avecDevise = false,
  signeExplicite = false,
  court = false,
  colorer = false,
  className,
}: MoneyProps) {
  if (centimes === null || centimes === undefined) {
    return <span className={cn('text-slate-500', className)}>{ABSENT}</span>
  }

  const texte = court
    ? formatMontantCourt(centimes)
    : formatMontant(centimes, { avecDevise, signeExplicite })

  return (
    <span
      className={cn(
        'chiffres-alignes whitespace-nowrap',
        colorer && (centimes < 0 ? 'text-red-700' : centimes > 0 ? 'text-emerald-700' : undefined),
        className,
      )}
    >
      {court && avecDevise ? `CHF ${texte}` : texte}
    </span>
  )
}
